<template>
    <div class="default content text-center">
        <!-- <h1>Velkommen til MålerTjek!</h1>
        <p>Klik på knappen for at komme i gang</p>
        <router-link class="button" :to="{name: 'init', params: {key: 'Key'}}">Start</router-link> -->
    </div>
</template>

<script>

export default {
    name: 'startpage',
    data() {
        return {
            msg: ''
        }
    },
    mounted() {
        var _this = this;
        $(document).foundation();
        $('header').hide();
        setTimeout(function() {
            _this.$router.push({
                name: 'init',
                params: {key: 'Key'}
            })
        }, 100)
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// default.vue?1c988d59